import { useEffect, useState } from "react";
import get from "lodash/get";

import { extractQueryParams } from "../../../utils/url";

const useQueryParams = (location, initialLocale) => {
  const [metadata, setMetadata] = useState({});
  const [locale, setLocale] = useState(initialLocale);
  const [params, setParams] = useState({});

  useEffect(() => {
    const query = extractQueryParams(location);
    // The query param locale should override the one already set in state
    const queryLocale = get(query, "locale");

    const utm_campaign = get(query, "utm_campaign");
    const utm_source = get(query, "utm_source");
    const utm_medium = get(query, "utm_medium");
    const utm_content = get(query, "utm_content");
    const member_id = get(query, "member_id");
    const ext_uuid = get(query, "ext_uuid");

    const survey_type = get(query, "survey_type");
    const page_id = get(query, "page_id");
    const question_id = get(query, "question_id");
    const block_display_logic = get(query, "block_display_logic", "true");
    const question_display_logic = get(query, "question_display_logic", "true");
    const question_required_logic = get(query, "question_required_logic", "true");

    setMetadata({
      utm_campaign,
      utm_source,
      utm_medium,
      utm_content,
      member_id,
      ext_uuid,
    });

    setLocale(queryLocale);

    setParams({
      surveyType: survey_type,
      pageId: page_id,
      questionId: question_id,
      blockDisplayLogic: block_display_logic === 'true',
      questionDisplayLogic: question_display_logic === 'true',
      questionRequiredLogic: question_required_logic === 'true',
    });
  }, [location]);

  return {
    metadata,
    params,
    queryLocale: locale,
    clearQueryParamLocale: () => setLocale(undefined)
  };
};

export default useQueryParams;
